import {

} from '@/api/attendance'
const state = {}
const mutations = {}

const actions = {
	// plEditbatchOrgAccBalanceLimit({}, data) {
	//   return new Promise((resolve, reject) => {
	//     plEditbatchOrgAccBalanceLimit(data)
	//       .then(res => {
	//         resolve(res);
	//       })
	//       .catch(error => {
	//         reject(error);
	//       });
	//   });
	// },

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
